<template>
  <van-popup v-model="showPicker" position="bottom" :lock-scroll="lockScroll">
    <div class="picker-popup">
      <van-picker :title="title" :valueKey="valueKey" :confirm-button-text="confirmButtonText" :cancel-button-text="cancelButtonText"
        show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" @change="onChange" />
    </div>
  </van-popup>
</template>
<script>
import { Popup, Picker } from 'vant';
export default {
  name: 'PickerPopup',
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: () => []
    },
    confirmText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'text'
    },
    lockScroll: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    confirmButtonText() {
      return this.confirmText || this.$t('confirm');
    },
    cancelButtonText() {
      return this.cancelText || this.$t('cancel');
    }
  },
  data() {
    return {
      showPicker: false
    }
  },
  methods: {
    open() {
      this.showPicker = true
    },
    close() {
      this.showPicker = false
    },
    onConfirm(value) {
      this.$emit('confirm', value)
      this.close()
    },
    onCancel() {
      this.$emit('cancel')
      this.close()
    },
    onChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="less" scoped>
.van-popup {
  border-radius: 20px 20px 0 0;
}

.picker-popup {
  padding-top: 30px;
}
</style>